/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import React, { useCallback, useState } from "react";
import get from "lodash/get";
import { array, object, shape, string, number } from "prop-types";
import { useSelector } from "react-redux";

import { AccessType, WithPreview } from "@quintype/components";
import StoryWrapper from "../story-templates/story-wrapper";
import { LatestMagazineIssues } from "../collection-templates/latest-magazine-issues";
import {
  getPerpetualConfig,
  PerpetualStoryFeed,
  PerpetualStoryItem,
  syncStoryBrowserState,
} from "./perpetual-story-feed";

import "./story.m.css";

function StoryPageBaseWithAccesstype({
  story,
  config,
  index,
  recommendedStories,
  params,
  magazineDetails,
  moreVideos
}) {
  const [isATGlobal, setIsATGlobal] = useState(false);
  const member = useSelector((state) => get(state, ["member"], null));
  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const email = get(member, ["email"], "");
  const phone = get(member, ["metadata", "phone-number"], "");
  const { key, accessTypeBkIntegrationId } = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "accesstypeConfig"], {})
  );
  const isWebView = get(qtState, ["config", "isWebView"]) === true;
  const perpetualScroll = getPerpetualConfig(config);
  const shouldRenderPerpetualScroll =
    perpetualScroll.enabled && perpetualScroll.templates.includes(story?.["story-template"]);
  const handleInitialStoryActive = useCallback((activeStory) => {
    syncStoryBrowserState(activeStory, { isPerpetualStory: false });
  }, []);

  return (
    <AccessType
      enableAccesstype={true}
      accessTypeKey={key}
      email={email}
      phone={phone}
      accessTypeBkIntegrationId={accessTypeBkIntegrationId}
      onATGlobalSet={() => {
        setIsATGlobal(true);
      }}
    >
      {({ initAccessType, checkAccess }) => (
        <div styleName="story-page-container">
          {shouldRenderPerpetualScroll ? (
            <PerpetualStoryItem story={story} onStoryActive={handleInitialStoryActive}>
              <StoryWrapper
                isATGlobal={isATGlobal}
                story={story}
                config={config}
                initAccessType={initAccessType}
                checkAccess={checkAccess}
                index={index}
                recommendedStories={recommendedStories}
                params={params}
                magazineDetails={magazineDetails}
                moreVideos={moreVideos}
              />
              {story?.["story-template"] === "magazine" && (
                <div styleName="story-elements-wrapper">
                  {!isWebView && <LatestMagazineIssues isStoryPage={true} story={story} config={config} />}
                </div>
              )}
            </PerpetualStoryItem>
          ) : (
            <>
              <StoryWrapper
                isATGlobal={isATGlobal}
                story={story}
                config={config}
                initAccessType={initAccessType}
                checkAccess={checkAccess}
                index={index}
                recommendedStories={recommendedStories}
                params={params}
                magazineDetails={magazineDetails}
                moreVideos={moreVideos}
              />
              {story?.["story-template"] === "magazine" && (
                <div styleName="story-elements-wrapper">
                  {!isWebView && <LatestMagazineIssues isStoryPage={true} story={story} config={config} />}
                </div>
              )}
            </>
          )}
          <PerpetualStoryFeed
            story={story}
            config={config}
            isATGlobal={isATGlobal}
            initAccessType={initAccessType}
            checkAccess={checkAccess}
            enabled={shouldRenderPerpetualScroll}
            storyCount={perpetualScroll.storyCount}
            templates={perpetualScroll.templates}
            continueReading={perpetualScroll.continueReading}
          />
        </div>
      )}
    </AccessType>
  );
}

StoryPageBaseWithAccesstype.propTypes = {
  story: object,
  config: object,
  index: number,
  recommendedStories: array,
  magazineDetails: object,
  moreVideos: object,
};

export function StoryPage({ data, config, index, params }) {
  if (!data) return;

  const { story, recommendedStories, magazineDetails, moreVideos } = data;

  return (
    <StoryPageBaseWithAccesstype
      story={story}
      config={config}
      index={index}
      recommendedStories={recommendedStories}
      params={params}
      magazineDetails={magazineDetails}
      moreVideos={moreVideos}
    />
  );
}

StoryPage.propTypes = {
  index: number,
  story: object,
  config: object,
  params: object,
};

StoryPage.propTypes = {
  data: shape({
    story: object,
    config: object,
  }),
  currentPath: string,
};

export const StoryPagePreview = WithPreview(StoryPage, (data, story) =>
  Object.assign({}, data, {
    story,
    recommendedStories: Array(5).fill(story),
  })
);
